// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import PriceRangeFields from '../SimpleFilter/PriceRangeFields';
import { addThousandSeparator } from '../../../../../utils/filters/usedVehicles/portalUsedVehiclesV2/makeFiltersPillData';
import { incrementFilter, removeFilter, setList } from '../../../../../stores/Filters/UsedVehicles/FilterV3';

class PriceRange extends Component {
  constructor(props) {
    super(props);

    this.handlePriceChange = this.handlePriceChange.bind(this);
  }

  handleClickMinPrice(value, filterKey) {
    removeFilter(filterKey === 'min_price' ? 'max_price' : 'min_price')
    incrementFilter({
      key: filterKey,
      value
    })
    setList()
  }

  handlePriceChange(filterKey) {
    return (event) => {
      const value = event.target.value
      const parsedValue = value.replace(/\./g, '')
      
      this.props.handleUpdateFilter(filterKey, parsedValue);
    }
  }

  handleInputChange(event) {
    let value = event.target.value
    value = value.replace(/[^\d.]/g, '')
    
    const cleanValue = value.replace(/\./g, '')
    const parsedValue = addThousandSeparator(cleanValue)
    
    event.target.value = parsedValue
  }
  
  render() {
    const { currentMinPrice, currentMaxPrice, handleUpdateFilter } = this.props;

    return ( 
      <div className="advanced-filter__price-range price-range-advanced">
        <h4 className="advanced-filter__section-title">Faixa de preço</h4>
        <div className="price-range-advanced__range-buttons">
          <button
            className="price-range-advanced__range-button"
            data-active={parseInt(currentMaxPrice) == 50000}
            onClick={() => this.handleClickMinPrice(50000, 'max_price')}
          >
            Até R$ 50.000
          </button>
          <button
            className="price-range-advanced__range-button"
            data-active={parseInt(currentMaxPrice) == 100000}
            onClick={() => this.handleClickMinPrice(100000, 'max_price')}
          >
            Até R$ 100.000
          </button>
          <button
            className="price-range-advanced__range-button"
            data-active={parseInt(currentMinPrice) == 100000}
            onClick={() => this.handleClickMinPrice(100000, 'min_price')}
          >
            Acima de R$ 100.000
          </button>
        </div>
        <PriceRangeFields
          handleInputChange={this.handleInputChange}
          handleMinPriceChange={this.handlePriceChange('min_price')}
          handleMaxPriceChange={this.handlePriceChange('max_price')}
          currentMinPrice={addThousandSeparator(currentMinPrice)}
          currentMaxPrice={addThousandSeparator(currentMaxPrice)}
        />
      </div>
    );
  }
}

PriceRange.defaultProps = {
  currentMinPrice: null,
  currentMaxPrice: null,
  handleUpdateFilter: () => {}
};

PriceRange.propTypes = {
  currentMinPrice: PropTypes.number,
  currentMaxPrice: PropTypes.number,
  handleUpdateFilter: PropTypes.func,
};

export default PriceRange;
